// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Dn-z","badgeLink":"En-z","category":"Fn-z"};